import { ProductNameLine } from 'autogen/swagger/all';
import usePageContext from 'hooks/user/usePageContext';
import React from 'react';
import PageTitleNameRenderer from './PageTitleNameRenderer';
import ChanelPageTitleNameRenderer from './ChanelPageTitleNameRenderer';

export default function PageTitleNameRendererMapper({ lines }: { lines: ProductNameLine[] }): JSX.Element {
    const pageContext = usePageContext();
    const brandContext = pageContext?.brandContext;

    return brandContext && brandContext === 'chanel' ? (
        <ChanelPageTitleNameRenderer lines={lines} />
    ) : (
        <PageTitleNameRenderer lines={lines} />
    );
}
